<template>
  <div>
   <van-form @submit="onSubmit" label-width="150px">
      <!-- <van-field
         v-model="username"
         name="用户名"
         label="用户名"
         placeholder="用户名"
         :rules="[{ required: true, message: '请填写用户名' }]"
      /> -->
      <van-field
         v-model="userInfo.password"
         :type="eyes?'username':'password'"
         name="password"
         label="新密码"
         :placeholder="placeholder"
         :rules="[{ required: true, message: '请输入6-20位数字、字母或特殊符号',validator:passwordYz,trigger:'onChange' }]"
         class="buttonField"
      >
         <template #button>
            <van-button size="small" @click="clickRightIcon('eyes')" native-type="button" style="border:none;">
               <svg-icon :icon-class="eyes?'eyes':'eyesable'" icon-style="font-size:0.5rem;"></svg-icon>
            </van-button>
         </template>
      </van-field>
      <div style="margin: 16px;">
         <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
   </van-form>
  </div>
</template>
<script>
   export default {
      data() {
         return {
            placeholder:"请输入6-20位数字、字母或特殊符号",
            userInfo: {},
            eyes:false,
         }
      },
      methods: {
         passwordYz(value,rule){
            let str = /^(?=.*[A-Z|a-z])(?=.*\d).{6,20}$/
            this.placeholder = "请输入密码"
            return str.test(value)
         },
         onSubmit(value) {
            this.$api.post("/payment/auth/user/qwForgotPassword",{
               reqData:{
                  newPassword:value.password
               }
            }).then(res=>{
               if(res.repCode === "0000"){
                  this.$notify({
                     type:"success",
                     message:"修改成功,请重新进入"
                  })
               }
            })
         },
         clickRightIcon(){
            this.eyes = !this.eyes
         },
      },
   }
</script>

<style>
   .buttonField .van-field__label{
      margin-top:4px;
   }
   .van-field__label {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      flex: none;
      box-sizing: border-box;
      width: 3em !important;
      margin-right: 0.32rem;
      color: #646566;
      text-align: left;
      word-wrap: break-word;
   }
</style>